import { Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "./Brand";
import { NAV_LINKS } from "../data/site";
import { waLink, telLink } from "../lib/api";
import { useContent } from "../context/ContentContext";
import { usePages } from "../context/PagesContext";

export const Footer = () => {
  const { footer, services, contact } = useContent();
  const pages = usePages();
  const footerPages = pages.filter((p) => p.show_in_footer);
  return (
    <footer className="bg-navy text-white" id="footer" data-testid="footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 md:grid-cols-2 lg:grid-cols-4 lg:px-8">
        <div>
          <Logo light />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">{footer.description}</p>
          <p className="mt-4 font-display text-sm font-bold tracking-wide text-gold">{footer.tagline}</p>
        </div>

        <div>
          <h4 className="text-sm font-bold uppercase tracking-widest text-gold">Quick Links</h4>
          <ul className="mt-4 space-y-2.5">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="text-sm text-white/70 transition-colors hover:text-white">{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold uppercase tracking-widest text-gold">Services</h4>
          <ul className="mt-4 space-y-2.5">
            {services.items.map((s) => (
              <li key={s.title}>
                <a href="/services" className="text-sm text-white/70 transition-colors hover:text-white">{s.title}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-bold uppercase tracking-widest text-gold">Get in Touch</h4>
          <ul className="mt-4 space-y-3">
            {[contact.whatsapp, contact.whatsapp2].filter(Boolean).map((n, i) => (
              <li key={i} className="flex items-start gap-3 text-sm text-white/70">
                <Phone size={18} className="mt-0.5 text-gold" />
                <span>
                  {n}
                  <span className="ml-2 inline-flex gap-2">
                    <a href={telLink(n)} className="text-gold hover:text-white">Call</a>
                    <span className="text-white/30">·</span>
                    <a href={waLink(n)} target="_blank" rel="noreferrer" className="text-gold hover:text-white">WhatsApp</a>
                  </span>
                </span>
              </li>
            ))}
            <li>
              <a href={`mailto:${contact.email}`} className="flex items-start gap-3 text-sm text-white/70 hover:text-white">
                <Mail size={18} className="mt-0.5 text-gold" /> {contact.email}
              </a>
            </li>
            <li className="flex items-start gap-3 text-sm text-white/70">
              <MapPin size={18} className="mt-0.5 text-gold" /> {contact.location}
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 text-xs text-white/50 sm:flex-row sm:px-6 lg:px-8">
          <p>© 2026 R.O.K Motors. All Rights Reserved.</p>
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            {footerPages.map((p) => (
              <a key={p.id} href={`/${p.path}`} className="hover:text-white">{p.title}</a>
            ))}
            <button
              type="button"
              onClick={() => window.dispatchEvent(new Event("open-cookie-consent"))}
              data-testid="footer-manage-cookies"
              className="hover:text-white"
            >
              Manage Cookies
            </button>
            <a href="/admin/login" className="hover:text-white">Admin</a>
          </div>
        </div>
        <div className="border-t border-white/10">
          <p className="py-4 text-center text-xs text-white/40" data-testid="developed-by">
            Developed by <span className="font-semibold text-gold">Domaleo IT Solutions</span>
          </p>
        </div>
      </div>
    </footer>
  );
};
